module.exports = __webpack_public_path__ + "static/media/ic-search.c723aa8e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dublin-express/ic-search.svg
// module id = 219
// module chunks = 0